import React, { useState } from 'react';
import { Alert, Form, Select, Spin } from 'antd';
import { useCountries } from './hooks';
import { ICountry } from 'models';

const Option = Select.Option;

export interface SelectedOption {
  id: string;
  name: string;
}

interface CountryDropdownProps {
  name: string;
  value?: SelectedOption;
  onChange?: (item: ICountry) => void;
  hideAll?: boolean;
  disabled?: boolean;
  required?: boolean;
}

const ALL_OPTION = { id: '-1', name: 'All countries' };

export function CountryDropdown(props: CountryDropdownProps) {
  const [value, setValue] = useState<string | undefined>(props.value?.id);

  const { loading, error, data } = useCountries();

  const handleChange = (value: string) => {
    setValue(value);
    if (props.onChange) {
      const obj = data?.find((i) => i.id === value);
      props.onChange(obj!);
    }
  };

  const renderOptions = () => {
    if (loading) {
      if (props.value?.id) {
        return [
          <Option key={props.value.id} value={props.value.id}>
            {props.value.name}
          </Option>,
        ];
      } else if (props.hideAll) {
        return [];
      }
    }

    const options = [];

    if (!props.hideAll) {
      options.push(ALL_OPTION);
    }

    if (data) {
      data.forEach((i) => options.push(i));
    }

    return options.map((i) => (
      <Option key={i.id} value={i.id}>
        {i.name}
      </Option>
    ));
  };

  const renderEmptyOrNotFoundContent = () => {
    if (loading) {
      return <Spin size="small" />;
    }
    if (error) {
      return <Alert showIcon={true} style={{ width: '100%' }} message={error} type="error" />;
    }
    return null;
  };

  return (
    <Form.Item name={props.name} label="Country" rules={[{ required: props.required, message: `Country is required` }]}>
      <Select style={{ width: '100%' }} value={value} disabled={props.disabled} placeholder="Select country" onChange={handleChange} loading={loading} notFoundContent={renderEmptyOrNotFoundContent()}>
        {renderOptions()}
      </Select>
    </Form.Item>
  );
}
